// extracted by mini-css-extract-plugin
module.exports = {"root":"EnquiryForm_root__3e8eG","icon":"EnquiryForm_icon__3hZ-o","heading":"EnquiryForm_heading__HWE7v","field":"EnquiryForm_field__2Dl2W","error":"EnquiryForm_error__3MAL8"};